module.exports = __webpack_public_path__ + "img/remove_icon.c0f7a0c2.png";